import React from 'react';
export const MoneyBackIcon = _ref => {
  let {
    width = 24,
    height = 24,
    color = '#000624'
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1C12.6421 1 16 4.35786 16 8.5C16 12.6421 12.6421 16 8.5 16C4.87156 16 1.84493 13.4234 1.15003 10H2.17393C2.8511 12.8667 5.42642 15 8.5 15C12.0899 15 15 12.0899 15 8.5C15 4.91015 12.0899 2 8.5 2C5.79605 2 3.71741 3.65105 2.7955 6H5V7H1V3H2V5.29964C3.12734 2.75827 5.50267 1 8.5 1ZM6 10H7C7 10.5523 7.44772 11 8 11H9C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9H8C6.89543 9 6 8.10457 6 7C6 5.89543 6.89543 5 8 5V4H9V5C10.1046 5 11 5.89543 11 7H10C10 6.44772 9.55228 6 9 6H8C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8H9C10.1046 8 11 8.89543 11 10C11 11.1046 10.1046 12 9 12V13H8V12C6.89543 12 6 11.1046 6 10Z",
    fill: color
  }));
};
//# sourceMappingURL=MoneyBackIcon.js.map